import HomeFormsPage from './pages/HomePage'

const routes = [
  {
    path: 'homepage',
    name: 'Formulário Dinâmico',
    component: HomeFormsPage
  }
]

export default routes